'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _components = require('../../components');
var _getLocalizedData2 = require('../../utils/getLocalizedData');var _getLocalizedData3 = _interopRequireDefault(_getLocalizedData2);
var _constants = require('../../constants');
var _CountriesList = require('./CountriesList.scss');var styles = _interopRequireWildcard(_CountriesList);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CountriesList = function CountriesList(props) {var

  buttonText =




  props.buttonText,countriesData = props.countriesData,locale = props.locale,toggleVisibilityCountriesList = props.toggleVisibilityCountriesList,isVisibleBtn = props.isVisibleBtn;

  var handleClick = function handleClick(tag) {
    props.clearSearchedAddress();
    _reactRouter.browserHistory.push((0, _appendLocale2.default)(locale, '/' + _constants.ROUTES_PATHS.FOREIGN + '/' + tag));
  };

  var getLocationName = function getLocationName(item) {var _getLocalizedData =
    (0, _getLocalizedData3.default)(item.localisation, locale, _constants.language.fallback),result = _getLocalizedData.result;
    return result;
  };

  var renderCountryCell = function renderCountryCell(item) {return (
      _react2.default.createElement(_components.CountryCell, {
        name: getLocationName(item),
        iso_code: item.iso_code,
        key: item.id,
        tag: item.name,
        count: item.property_count.total,
        handleClick: handleClick }));};



  return (
    _react2.default.createElement('div', { className: styles.row },
      countriesData.map(renderCountryCell),
      isVisibleBtn &&
      _react2.default.createElement('button', {
          onClick: toggleVisibilityCountriesList,
          className: styles.btnShow },

        buttonText)));



};

CountriesList.propTypes = {
  buttonText: _propTypes2.default.string,
  toggleVisibilityCountriesList: _propTypes2.default.func,
  countriesData: _propTypes2.default.array,
  isVisibleBtn: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  clearSearchedAddress: _propTypes2.default.func };exports.default =


CountriesList;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CountriesList/CountriesList.js
// module id = 2648
// module chunks = 0